// Define the model for the query parameters
import {TplReportDto} from "../dto/tpl-report-dto";
import {Injectable} from "@angular/core";
import {HttpClient, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";
import {FromToDateModel} from "../models/from-to-date-model";

@Injectable({
  providedIn: 'root'
})
export class TplReportService {

  private apiPath = 'tpl-report';  // Base URL for the API

  constructor(private http: HttpClient) { }

  // Function to get TPL Report
  getMonthlyTplReport(model: FromToDateModel): Observable<TplReportDto> {
    // Set up query parameters
    const params = new HttpParams()
      .set('from', model.FromDate)
      .set('to', model.ToDate);

    // Make GET request to API endpoint
    return this.http.get<TplReportDto>(`${this.apiPath}/month`, { params });
  }

  getQuarterlyTplReport(model: FromToDateModel): Observable<TplReportDto> {
    // Set up query parameters
    const params = new HttpParams()
      .set('from', model.FromDate)
      .set('to', model.ToDate);

    // Make GET request to API endpoint
    return this.http.get<TplReportDto>(`${this.apiPath}/quarter`, { params });
  }
}
